import React, { useRef } from "react";
import { mediaUrl, mediaSrcSet } from "@/lib/api";
import { motion, useScroll, useTransform } from "framer-motion";

const HAND_IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_57cd04de-09a7-4fd0-831f-2a39acb3f37f/artifacts/jcxqny7o_7WhatsApp%20Image%202026-08-01%20at%2015.04.23.jpeg";

const CHAPTERS = [
  { n: "01", title: "The Biga", body: "A 72-hour fermented pre-ferment gives our dough its wild, open crumb and a crust that shatters, then melts." },
  { n: "02", title: "The Bake", body: "Baked in trays Roman-style — deep, airy, golden at the edges, blistered underneath. Served as whole pizzas, never sliced-and-warmed." },
  { n: "03", title: "The Toppings", body: "Buffalo mozzarella, confit garlic, hot honey and produce sourced weekly. Nothing frozen, ever." },
];

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="story" ref={ref} className="bg-biga-ink text-biga-cream py-20 sm:py-32 px-5 sm:px-8 relative overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] border-2 border-biga-cream/10">
            <motion.img style={{ y }} src={mediaUrl(HAND_IMG, 640)} srcSet={mediaSrcSet(HAND_IMG, [640, 1280])} sizes="(max-width: 1024px) 100vw, 50vw" loading="lazy" decoding="async" alt="Hand holding a Roman-style pizza slab" className="w-full h-[116%] object-cover" />
          </div>
          <div className="absolute -bottom-5 -right-3 bg-biga-orange text-biga-cream font-display font-black text-xl px-5 py-3 rounded-2xl rotate-[-4deg]">
            Since day one.
          </div>
        </div>

        <div>
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-biga-orange">Our Manifesto</span>
          <h2 className="font-display font-black text-5xl sm:text-6xl leading-[0.9] mt-3 mb-10">
            Slow dough.<br />Loud flavour.
          </h2>
          <div className="space-y-8">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
                className="flex gap-5 border-t border-biga-cream/15 pt-5"
              >
                <span className="font-display font-black text-3xl text-biga-orange shrink-0">{c.n}</span>
                <div>
                  <h3 className="font-display font-bold text-2xl mb-1">{c.title}</h3>
                  <p className="text-biga-cream/70 font-medium">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
